module.exports = __webpack_public_path__ + "static/media/i4c-race.4dc4bd9d.svg";